import React from 'react'
import Slider from 'react-slick'
import test_1 from '../../../assets/images/testimonial/testimonial-1.png'
import test_2 from '../../../assets/images/testimonial/testimonial-2.png'
import test_3 from '../../../assets/images/testimonial/testimonial-3.png'
import test_4 from '../../../assets/images/testimonial/testimonial-4.png'
import test_5 from '../../../assets/images/svg/cote.svg'

const Testimonial = () => {
    return (
        <>
            <div className="testimonial-section-one">
                <div className="container">
                    <div className="heading-box text-center">
                        <span className="sub-title">our client say</span>
                    </div>
                    <div className="row">
                        <div className="col-lg-8 m-auto">
                            <Slider className="testimonial-slider-one" >
                                <div className="testimonial-item-one">
                                    <div className="testimonial-author-image">
                                        <img
                                            src={test_1}
                                            alt="author-image"
                                        />
                                    </div>
                                    <h5>
                                        Vulputate mi sit amet mauris commodo quis imperdiet. Metus
                                        vulputate eu felis imperdiet proin nulla aliquet enim.
                                    </h5>
                                    <img src={test_5} alt="icon" />
                                    <p>John Doue , Digital marketing</p>
                                </div>
                                <div className="testimonial-item-one">
                                    <div className="testimonial-author-image">
                                        <img
                                            src={test_2}
                                            alt="author-image"
                                        />
                                    </div>
                                    <h5>
                                        Vulputate mi sit amet mauris commodo quis imperdiet. Metus
                                        vulputate eu felis imperdiet proin nulla aliquet enim.
                                    </h5>
                                    <img src={test_5} alt="icon" />
                                    <p>Neil Patel , Social Media Marketing</p>
                                </div>
                                <div className="testimonial-item-one">
                                    <div className="testimonial-author-image">
                                        <img
                                            src={test_3}
                                            alt="author-image"
                                        />
                                    </div>
                                    <h5>
                                        Vulputate mi sit amet mauris commodo quis imperdiet. Metus
                                        vulputate eu felis imperdiet proin nulla aliquet enim.
                                    </h5>
                                    <img src={test_5} alt="icon" />
                                    <p>Rand Fishkin , Content Marketing</p>
                                </div>
                                <div className="testimonial-item-one">
                                    <div className="testimonial-author-image">
                                        <img
                                            src={test_4}
                                            alt="author-image"
                                        />
                                    </div>
                                    <h5>
                                        Vulputate mi sit amet mauris commodo quis imperdiet. Metus
                                        vulputate eu felis imperdiet proin nulla aliquet enim.
                                    </h5>
                                    <img src={test_5} alt="icon" />
                                    <p>Mari Smith , SEO</p>
                                </div>
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Testimonial
